import React from 'react'

const OutlinedBtn = ({ onClick, title }) => {
  return (
    <button onClick={onClick} type="button" className='w-full h-[46px] border border-Primary rounded-[5px] text-Primary hover:text-white duration-200 hover:bg-Primary flex justify-center items-center font-Roborto text-paraText max_md:text-paraTextTab font-medium pt-[2px]'>{title}</button>
  )
}

export default OutlinedBtn